import PageLayout from "@components/PageLayout";
import { StableVault } from "@components/V2/Vault";
import { StableVaultProider } from "@providers/StableVaultProvider";
import { fetchStrapiData } from "@services/strapi";

export const getStaticProps = async () => {
  // Fetch CMS data at build time (not real-time API data)
  const res = await fetchStrapiData("strategy-allocations");

  return {
    props: {
      page: {
        data: {
          cmsAllocations: (() => {
            if (res?.data?.length > 0) {
              const vaultData = res.data.find(
                (data: any) => data?.attributes?.vault_name === "stable_vault"
              );

              return vaultData?.attributes || [];
            }
            return [];
          })(),
        },
      },
    },
  };
};

const StableVaultPage = (props: { page: any }) => {
  return (
    <PageLayout extraMarginTop={false}>
      <StableVaultProider
        data={{ cmsAllocations: props.page.data.cmsAllocations }}
      >
        <StableVault />
      </StableVaultProider>
    </PageLayout>
  );
};

export default StableVaultPage;
